import React from "react";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { StyledContainer } from "../../globalStyle/GlobalStyle";
import SchemeHeader from "./sections/SchemeHeader";
import SchemeDataTable from "./Partials/SchemeDataTable";
import { TableHeader, dummyData } from "./data";
import { Outlet, useParams } from "react-router";

function Scheme() {
	const { id } = useParams();
	console.log(" scheme id", id);
	const handleDeleteScheme = () => {
		console.log("delete scheme");
	};
	return (
		<AdminDashboardLayout>
			<StyledContainer>
				{id ? (
					<Outlet />
				) : (
                    <>
                    <SchemeHeader />
					<SchemeDataTable
						TableData={dummyData}
						headCells={TableHeader}
						handleDeleteAF={handleDeleteScheme}
					/>
                    </>
				)}
			</StyledContainer>
		</AdminDashboardLayout>
	);
}

export default Scheme;
